import * as constants from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/config/constants.js';
import Selectors from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/selectors.js';
import FormValidator from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/form-validator';
import Address from './address/address.js';
import Insurance from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/insurance.js';
import ExistingNumber from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/existing-number.js';
import DeliveryAddress from './address/delivery-address.js';
import DeliveryPicker from './delivery-picker.js';
import JobTitleFilter from './jobtitle-filter.js';
import FormPartValidator from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/form-part-validator';
import GiftPopup from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/gift-popup.js';
import ElementClassHandler from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/element-class-handler.js';
import AutoTabFields from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/auto-tab-fields.js';
import SectionControl from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/section-control.js';
import 'jquery.growl';
import '../../vendor/cdt/checkout/src/checkout-web/src/scripts/stock-message.js';
import 'nodelist-foreach-polyfill';
import DeliveryCutoff from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/delivery-cutoff.js';
import LoadingOverlay from './loading-overlay.js';
import './basket/basket-section-load.js';
import './basket/basket-show-details.js';
import networkSwitching from './network-switching';
import esim from './esim';
import eSimTypeCompatibleChecker from './compatible-checker';
var organicSource = 'Yes';
// eslint-disable-next-line no-unused-vars
if (window.location.href.includes('checkout/order-placed')) {
    localStorage.removeItem('organicSource');
} else if (localStorage.getItem('organicSource') === null) {
    organicSource = (window.location.href.includes('utm_source') || window.location.href.includes('utm_medium') || window.location.href.includes('utm_campaign') || window.location.href.includes('affiliate') || window.location.href.includes('awc')) ? 'No' : 'Yes';
    localStorage.setItem('organicSource', organicSource);
} else {
    organicSource = localStorage.getItem('organicSource');
}
const windowScrollLimit = document.body.scrollHeight - window.innerHeight,
    toggleFixedStart = 200,
    toggleFixedReset = 120,
    selectors = new Selectors(),
    mdlSelectFields = selectors.querySelectorArray('.' + constants.MDL_SELECTFIELD_SELECT_CLASS),
    popupLinks = selectors.querySelectorArray('[data-class-toggle]');

jQuery.noConflict();

jQuery(document).ready(() => {

    if (document.querySelector('#stepModal')) {
        $('#stepModal').modal('show').on('hidden.bs.modal', () => {
            if (document.querySelector('#step_modal_redirect_url')) {
                document.location.href = document.querySelector('#step_modal_redirect_url').value;
            }
        });
    }

    if (document.querySelector('#payment_validation_modal')) {
        $('#payment_validation_modal').modal('show');
    }

    if (document.querySelector('#payment_redirect_form')) {
        $('#payment_modal').modal('show');
        $('#payment_redirect_form').submit();
    }
    esim();
});

if (document.querySelector('[data-bill-capping-section]')) {
    document.querySelectorAll('[data-bill-capping-section]').forEach(function(element) {
        let dealLineId = element.getAttribute('data-deal-line-public-id');
        (new SectionControl({
            'toggleIdentifier': '[id$="' + dealLineId + '_billCappingDecision"]',
            'targetIdentifier': '[data-' + dealLineId + '-bill-capping-amount-section]',
            'toggleRequiredSelect': true
        })).setup();

        document.querySelectorAll('[data-' + dealLineId + '-bill-capping-amount-section] select').forEach(function(element) {
            if (element.offsetParent === null) {
                element.required = false;
            }
        });
    });
    if (document.querySelector('#basket-form')) {
        const basketForm = document.querySelector('#basket-form');
        if (basketForm && !basketForm.dataset.hasSubmitListener) {
            basketForm.addEventListener('submit', () => {
                document.querySelectorAll('[form="basket-form"]').forEach(function(element) {
                    let clone = element.cloneNode(true);
                    clone.hidden = true;
                    clone.value = element.value;
                    basketForm.appendChild(clone);
                    return true;
                });
            });
        }
    }
}

if ($('#form_email_email_first').length) {
    $('#form_email_email_first').bind('input propertychange', function(e) {
        const blockedEmails = [
            'na@na.com',
            'na@mail.com',
            'g@gmail.com',
            'no@no.com',
            'email@email.com',
            'l@gmail.com',
            'n@gmail.com',
            'lllll@gmail.com',
            'none@gmail.com',
            'x@gmail.com',
            'na@gmail.com'
        ];
        const emailValue = $(this).val().trim().toLowerCase();
        let emailEmailFirst = $(this);
        if (blockedEmails.includes(emailValue)) {
            $(this).val('');
            $(this).focus();
            if (!$('span').hasClass('errorMessageEmailEmailFirst')) {
                emailEmailFirst.after('<span class="errorMessageEmailEmailFirst" style="box-sizing: border-box;width: 100%;color: #d0021b;font-size: 14px;"> This email address is not allowed. Please use a valid email. </span>');
            }
            setTimeout(function() {
                $('.errorMessageEmailEmailFirst').fadeTo(0, 5000);
                $('.errorMessageEmailEmailFirst').remove();
            }, 10000);
            e.preventDefault();
        }
    });
}

if (document.querySelector('[name]')) {
    (new FormValidator({
        'matchFields': {
            '#form_email_email_second': '#form_email_email_first',
        }
    })).setup();
}

if (document.querySelector('[data-delivery-cutoff-message]')) {
    (new DeliveryCutoff()).setup();
}

if (document.querySelector('[data-delivery-selection-id="containing-block"]')) {
    (new DeliveryPicker({
        'elementIdentifier': 'delivery_selection'
    })).setup();
}

if (document.querySelector('[data-address-id="billing_address_block"]')) {
    (new Address({
        'multipleAddresses': true,
        'durationFields': true,
        'addressType': 'billing-address',
        'elementIdentifier': 'billing_address',
        'searchForm': 'billing_address_search_form',
        'manualForm': 'billing_address_manual_form',
        'enableForm': 'deliveryAddressEnable'
    })).setup();
}

if (document.querySelector('[data-address-id="delivery_address_block"]')) {
    (new DeliveryAddress({
        'addressType': 'delivery-address',
        'elementIdentifier': 'delivery_address',
        'searchForm': 'delivery_address_search_form',
        'manualForm': 'delivery_address_manual_form',
        'enableForm': 'deliveryAddressEnable'
    })).setup();
}

if (document.querySelector('[data-insurance]')) {
    (new Insurance({})).setup();
}

if (document.querySelector('[data-existing-number-id]')) {
    (new ExistingNumber({})).setup();
}

if (document.querySelector('.' + constants.MDL_TOOLTIP_CLASS)) {

    MaterialTooltip.prototype.handleMouseClick = function(event) {
        event.preventDefault();
        if (this.element_.parentNode.classList.contains(constants.MDL_TEXTFIELD_CLASS)) {
            this.element_.classList.add(this.CssClasses_.IS_ACTIVE);
        } else {
            this.element_.MaterialTooltip.handleMouseEnter_(event);
        }
    };

    MaterialTooltip.prototype.init = function() {
        if (this.element_) {
            let forElId = this.element_.getAttribute('data-mdl-for');
            if (forElId) {
                this.forElement_ = document.querySelector('[data-mdl-tooltip-id="' + forElId + '"]');
            }
            if (this.forElement_) {
                if (!this.forElement_.hasAttribute('tabindex')) {
                    this.forElement_.setAttribute('tabindex', '0');
                }
                this.boundMouseClickHandler = this.handleMouseClick.bind(this);
                this.boundMouseLeaveAndScrollHandler = this.hideTooltip_.bind(this);
                this.forElement_.addEventListener('click', this.boundMouseClickHandler, false);
                this.forElement_.addEventListener('touchend', this.boundMouseEnterHandler, false);
                this.forElement_.addEventListener('mouseleave', this.boundMouseLeaveAndScrollHandler, false);
                window.addEventListener('scroll', this.boundMouseLeaveAndScrollHandler, true);
                window.addEventListener('touchstart', this.boundMouseLeaveAndScrollHandler);
            }
        }
    };
}

if (document.querySelector('[data-gift-popup]')) {
    (new GiftPopup({})).setup();
}

if (document.querySelector('[data-group-membership-section]')) {
    (new SectionControl({
        'toggleIdentifier': '#form_marketingPreferences_groupMembershipAccepted_row input',
        'targetIdentifier': '[data-group-membership-section]',
    })).setup();
}

if (popupLinks.length) {
    popupLinks.forEach((element) => {
        element.addEventListener('click', function() {
            let className = element.getAttribute('data-class-toggle');
            let classTarget = '[data-class-toggle-id="' + className + '"]';
            if (document.querySelector(classTarget)) {
                let classTargets = selectors.querySelectorArray(classTarget);
                classTargets.forEach(function() {
                    let elementClassHandler = new ElementClassHandler;
                    elementClassHandler.toggle(document.querySelector(classTarget), className);
                });
            }
        });
    });
}

if (document.querySelector('#form_employment_employmentStatus')) {
    (new JobTitleFilter({
        'employmentStatusFormElement': 'select#form_employment_employmentStatus',
        'timeWithEmployerLabel': "label[for='form_employment_timeWithEmployer']",
        'jobTitleLabel': "label[for='form_employment_jobTitle']",
        'timeWithEmployerLabelMappings': {
            'student': 'a student',
            'house person': 'a house person'
        }
    })).setup();
}

if (document.querySelector('#form_email_email_second')) {
    document.querySelector('#form_email_email_second').addEventListener('paste', (e) => {
        e.preventDefault();
    });
}

if (document.querySelector('#form_bank')) {
    new FormPartValidator({
        formSectionSelector: '#form_bank',
        url: '/bank-details/validate/bank',
    });
}

if (document.querySelector('#form_dateOfBirth_dateOfBirth_row')) {
    new AutoTabFields({
        id: '#form_dateOfBirth_dateOfBirth_row'
    });
}

if (document.querySelector('#form_bank_row')) {
    new AutoTabFields({
        id: '#form_bank_row'
    });
}

document.addEventListener('DOMContentLoaded', () => {
    componentHandler.registerUpgradedCallback('MaterialTextfield', (textfield) => {
        let mdlTextfield = textfield.querySelector('.' + constants.MDL_TEXTFIELD_INPUT_CLASS);
        if (mdlTextfield) {
            if (mdlTextfield.hasAttribute('data-required')) {
                mdlTextfield.setAttribute('required', 'required');
                mdlTextfield.removeAttribute('data-required');
            }
        }
    });
});

if (mdlSelectFields.length) {
    mdlSelectFields.forEach((element) => {
        element.addEventListener('change', (e) => {
            element.parentElement.querySelector('.' + constants.MDL_SELECTFIELD_VALUE_CLASS).innerHTML =
            element.querySelector('option[value="' + e.target.value + '"]').innerHTML;
            element.parentNode.MaterialSelectfield.checkValidity();
        });
    });
}

if (windowScrollLimit > toggleFixedStart) {
    const summaryFixedClass = 'basket-summary-toggle-fixed';
    window.addEventListener('scroll', function() {
        let topOffset = window.scrollY;
        let section = document.querySelector('.basket-summary-toggle');
        if (section) {
            if (topOffset > toggleFixedStart + 20 && !section.className.includes(summaryFixedClass)) {
                section.className += ' ' + summaryFixedClass;
            } else if (topOffset < toggleFixedReset && section.className.includes(summaryFixedClass)) {
                section.className = section.className.replace(' ' + summaryFixedClass, '');
            }
        }
    });
}

if (document.querySelector('.summary-step form')) {
    document.querySelector('.summary-step form').addEventListener('submit', function() {
        document.querySelector('.terms-conditions-checkbox button').disabled = true;
    });
}

if (document.querySelector('[data-throbber]')) {
    var loadingOverlay = new LoadingOverlay,
        element = document.querySelector('[data-throbber]');

    element.addEventListener('click', function() {
        if (document.querySelector('.has-error')) {
            return false;
        }

        loadingOverlay.setMessage(element.getAttribute('data-throbber-message'));
        loadingOverlay.taskStarted(element.getAttribute('data-throbber-timeout'));
    });
}

networkSwitching();
eSimTypeCompatibleChecker();
